import { render, staticRenderFns } from "./PublicDashboardList.vue?vue&type=template&id=41265c24&"
import script from "./PublicDashboardList.vue?vue&type=script&lang=js&"
export * from "./PublicDashboardList.vue?vue&type=script&lang=js&"
import style0 from "./PublicDashboardList.vue?vue&type=style&index=0&id=41265c24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports